<template>
  <div class="vpc-layout-auth">
    <div
      v-scrollbar
      class="vpc-auth-container"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'VpcLayoutAuth',
}
</script>

<style lang="scss">
@import '@/views/auth/auth-page-form.scss';

.vpc-layout-auth {
  width: 100%;
  height: 100%;
  display: flex;
}

.vpc-auth-container {
  width: 100%;
  min-height: 100%;
  display: flex;
  align-items: center;

  @include _mobile-only {
    min-height: unset;
  }
}
</style>
